import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = Parameters<typeof DigiobcanApi.adminGetAiRuns>[0];

export const adminGetAiRuns = createQueryFn(
  QueryNameSpace.adminGetAiRuns,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    return DigiobcanApi.adminGetAiRuns(params);
  },
);
